import React, { useCallback, useState } from 'react';
import Layout from '../Layout';
import { Box, Button, Flex, Icon, SimpleGrid, Text } from '@chakra-ui/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import QuizCardBody from './QuizCardBody';
import { getAuthToken } from '../Helpers/script';
import { useAuth } from '../../Context/AuthContext';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const Header = ({
  score,
  totalQuestions,
  handleNav,
  currentIndex,
  handleShowSolution,
}) => {
  return (
    <>
      {currentIndex === -1 ? (
        <Flex direction="column" alignItems="center" color="#1B2559">
          <Text fontSize={{ base: '2rem', sm: '2.8rem' }}>
            Quiz <span style={{ color: '#4318FF' }}> Score Card</span>
          </Text>
          <Text fontSize={{ base: '1.3rem', sm: '2rem' }}>
            Total: {score}/{totalQuestions} 🎉
          </Text>
        </Flex>
      ) : (
        <Box>
          <Flex justifyContent="end">
            <Button mt="-20px" onClick={() => handleShowSolution('')}>
              Back to ScoreCard
            </Button>
          </Flex>

          <Flex justifyContent="space-between" p={4} mb={4}>
            <Icon
              as={FaChevronLeft}
              color="#101828"
              p="0.5rem"
              w="2rem"
              height="2rem"
              cursor="pointer"
              onClick={() => handleNav('prev')}
            />
            <Icon
              as={FaChevronRight}
              color="#101828"
              p="0.5rem"
              w="2rem"
              height="2rem"
              cursor="pointer"
              onClick={() => handleNav('next')}
            />
          </Flex>

          <Text fontSize="34px" color="#1b254b" fontWeight="700">
            Question {currentIndex + 1}
          </Text>
        </Box>
      )}
    </>
  );
};

const Body = ({
  score,
  quizAnswers,
  quizQuestions,
  userResponses,
  showSolution,
  handleShowSolution,
}) => {
  const { currentUser } = useAuth();
  const history = useHistory();

  const handleClick = id => {
    handleShowSolution(id);
  };

  const handleGenerateNewQuiz = async () => {
    // get the corresponding notes id using quizID and courseName
    // redirect to the TestMe page with the notes id

    // getQuizNotesRelation

    const urlParams = new URLSearchParams(window.location.search);
    const quizID = urlParams.get('id');
    const courseName = urlParams.get('courseName');

    const payload = {
      quizID,
      courseName,
    };

    try {
      const token = await getAuthToken(currentUser);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL ?? ''}/api/getQuizNotesRelation`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Handle success response here if necessary

      if (response.status === 200) {
        const { notesId } = response.data;
        history.push(`/configureQuiz?notesId=${notesId}&course=${courseName}`);
        // redirect to TestMe page with notesID
        // history.push(`/testme?notesID=${notesID}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {showSolution ? (
        <QuizCardBody
          userResponses={userResponses}
          question={quizQuestions.find(ques => ques.key === showSolution)}
          answer={quizAnswers[showSolution]}
          totalQuestions={quizQuestions.length}
          currentIndex={quizQuestions.findIndex(
            ques => ques.key === showSolution
          )}
        />
      ) : (
        <Flex direction="column" alignItems="center" color="#1B2559">
          <Flex
            direction="column"
            alignItems="center"
            color="#1B2559"
            width="100%"
          >
            <Text fontSize="1.5rem" mt="20px" width="100%">
              Questions:
            </Text>
            <SimpleGrid
              minChildWidth="220px"
              // maxWidth="256px"
              spacing="40px"
              mt="20px"
              width="100%"
            >
              {quizQuestions?.map((ques, i) => {
                const isAttempted = userResponses[ques.key] !== undefined;
                const isCorrect = quizAnswers[ques.key]?.options?.includes(
                  userResponses[ques.key]
                );

                return (
                  <Flex
                    key={ques.key}
                    id={ques.key}
                    justifyContent="space-between"
                    alignItems="center"
                    bg={
                      isAttempted && isCorrect
                        ? '#49C78E'
                        : isAttempted && !isCorrect
                        ? '#EC7171'
                        : '#2d81ff'
                    }
                    // background: #EC7171;
                    color="white"
                    height="45px"
                    p="0.5rem 0.8rem"
                    borderRadius="6px"
                    cursor="pointer"
                    onClick={() => handleClick(ques.key)}
                  >
                    <Text>#{i + 1}</Text>
                    <Icon as={FaChevronRight} />
                  </Flex>
                );
              })}
            </SimpleGrid>
          </Flex>
          <Button
            w="220px"
            mt="50px"
            bg="linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)"
            _hover={{
              background:
                'linear-gradient(15.46deg, #183f73 26.3%, #7B5AFF 86.4%)',
            }}
            color="white"
            onClick={handleGenerateNewQuiz}
          >
            Generate Another Quiz
          </Button>
        </Flex>
      )}
    </>
  );
};

const QuizScoreCard = ({
  score,
  quizAnswers,
  quizQuestions,
  userResponses,
}) => {
  const [showSolution, setShowSolution] = useState('');

  const handleQuestionIndex = useCallback(
    direction => {
      // find the index of the showSolution in quizQuestions
      const index = quizQuestions.findIndex(ques => ques.key === showSolution);

      if (direction === 'next') {
        if (index < quizQuestions.length - 1) {
          setShowSolution(quizQuestions[index + 1].key);
        }
      } else if (direction === 'prev') {
        if (index > 0) {
          setShowSolution(quizQuestions[index - 1].key);
        }
      }
    },
    [quizQuestions, showSolution]
  );

  const handleHeaderRenderer = useCallback(() => {
    return (
      <Header
        score={score}
        handleNav={handleQuestionIndex}
        totalQuestions={quizQuestions.length}
        currentIndex={quizQuestions.findIndex(
          ques => ques.key === showSolution
        )}
        handleShowSolution={quesID => setShowSolution(quesID)}
      />
    );
  }, [score, quizQuestions, handleQuestionIndex, showSolution]);

  const handleBodyRenderer = useCallback(() => {
    return (
      <Body
        score={score}
        quizAnswers={quizAnswers}
        quizQuestions={quizQuestions}
        userResponses={userResponses}
        showSolution={showSolution}
        handleShowSolution={quesID => setShowSolution(quesID)}
      />
    );
  }, [score, quizAnswers, quizQuestions, userResponses, showSolution]);

  return (
    <Layout
      header={handleHeaderRenderer}
      body={handleBodyRenderer}
      hasGenericFooter={true}
    />
  );
};

export default QuizScoreCard;
